import sileo from 'sileo';

const Workforce = new sileo.Model('hqzen', 'workforces');
const WorkforceEmployee = new sileo.Model('hqzen', 'workforce-employees');
const WorkforceDepartment = new sileo.Model('hqzen', 'workforce-departments');
const workforceExecutives = new sileo.Model('hqzen', 'workforce-executives');
const WorkforceFreePartner = new sileo.Model('hqzen', 'workforce-free-partners');
const simpleWorkforceExecutives = new sileo.Model('hqzen', 'simple-workforce-executives');
const WorkforceExecutiveInvitation = new sileo.Model('hqzen', 'workforce-executive-invitation');
const WorkforceOnboardEmployees = new sileo.Model('hqzen', 'workforce-onboard-employees');
const WorkforceWorkforceTodoCount = new sileo.Model('hqzen', 'workforce-sidebar-todos');
const AllCompanyWorkforces = new sileo.Model('hqzen', 'filtered-orgexec-workforce');
const AllWorkforceFacilities = new sileo.Model('hqzen', 'all-facility');
const AWSWorkforceImage = new sileo.Model('hqzen', 'aws-workforce-images');
const NavigationWorkforce = new sileo.Model('hqzen', 'navigation-workforces');
const WorkforceHRAdmins = new sileo.Model('hqzen', 'workforce-hr-admins');
const PlatformSettingsWorkforce = new sileo.Model('hqzen', 'platform-settings-workforces');
const WorkforceFacilitites = new sileo.Model('hqzen', 'facility-workforce-exec');
const WorkforceFacilityEmployments = new sileo.Model('hqzen', 'facility-employments');
const FacilityDetailsResource = new sileo.Model('hqzen', 'facility-details');
const WorkforcesAndDepartments = new sileo.Model('board', 'workforces-and-departments');
const WorkforcesList = new sileo.Model('hqzen', 'workforces-list');
const UserPinnedWorkforces = new sileo.Model('hqzen', 'user-pinned-workforces');

const state = {
    departments: [],
    employees: [],
    workforces: [],
    selectedWorkforce: null,
    navigations: [],
    isFetchingWorkforceSidebarTodo: false,
    workforceSidebarTodoCount: {},
    archivedWorkforcePk: null,
};

const getters = {
    workforces: state => state.workforces,
    departments: state => state.departments,
    employees: state => state.employees,
    navigations: state => state.navigations,
    isFetchingWorkforceSidebarTodo: state => state.isFetchingWorkforceSidebarTodo,
    workforceSidebarTodoCount: state => state.workforceSidebarTodoCount,
    archivedWorkforcePk: state => state.archivedWorkforcePk,

    departmentsByWorkforce: state => {
        if (!state.departments.length || !state.workforces.length) return {};

        const departments = {};
        state.workforces.forEach(({ pk }) => {
            departments[pk] = state.departments.filter(({ workforce_id }) => workforce_id === pk);
        });
        return departments;
    },

    teamsByWorkforce: state => {
        if (!state.departments.length || !state.workforces.length) return {};

        const teams = {};
        state.workforces.forEach(({ pk }) => {
            const depts = state.departments.filter(({ workforce_id }) => workforce_id === pk);
            const deptsWithTeam = {};
            depts.forEach(dept => {
                if (dept.teams.length > 0) {
                    dept.teams.forEach(team => {
                        team['department_name'] = dept.name;
                    });
                    deptsWithTeam[dept.pk] = dept.teams;
                }
            });
            if (Object.keys(deptsWithTeam).length !== 0)
                teams[pk] = deptsWithTeam;
        });
        return teams;
    }
};

const mutations = {
    setSelectedWorkforce(state, workforce) {
        state.selectedWorkforce = workforce;
    },

    patchSelectedWorkforce(state, patch) {
        if (!state.selectedWorkforce) return;
        Object.assign(state.selectedWorkforce, patch);
    },

    setDepartments(state, payload) {
        state.departments = payload;
    },

    setEmployees(state, payload) {
        state.employees = payload;
    },

    setNavigations(state, payload) {
        state.navigations = payload;
    },

    setWorkforces(state, workforces) {
        state.workforces = [...workforces];
    },

    setWorkforceSidebarTodoCount(state, todos) {
        Object.assign(state.workforceSidebarTodoCount, todos);
    },

    clearWorkforces(state) {
        state.workforces = [];
    },

    setIsFetchingWorkforceSidebarTodo(state, isFetching) {
        state.isFetchingWorkforceSidebarTodo = isFetching;
    },

    setArchivedWorkforcePk(state, pk) {
        state.archivedWorkforcePk = pk;
    }
};

const actions = {
    getWorkforce(context, pk) {
        return Workforce.objects.get(pk);
    },

    fetchWorkforces(context, filters) {
        return Workforce.objects.filter(filters);
    },

    createWorkforce(context, data) {
        return Workforce.objects.create(data);
    },

    fetchWorkforceEmployees(context, filters) {
        return WorkforceEmployee.objects.filter(filters);
    },

    fetchDepartments(context, filters) {
        return WorkforceDepartment.objects.filter(filters);
    },

    fetchWorkforceDepartments({ commit }, filters) {
        return WorkforceDepartment.objects.filter(filters)
            .then(data => {
                commit('setDepartments', data);
                return data;
            });
    },

    fetchWorkforceHRAdmins(context, filters) {
        return WorkforceHRAdmins.objects.filter(filters);
    },

    updateWorkforce(context, { filters, data }) {
        let form = new FormData();

        for (let field in data) {
            form.append(field, data[field]);
        }

        return Workforce.objects.update(filters, form);
    },

    fetchWorkforceExecutives(context,filters) {
        return workforceExecutives.objects.filter(filters);
    },

    fetchWorkforceFreePartners(context, filters) {
        return WorkforceFreePartner.objects.filter(filters);
    },

    fetchAllCompanyWorkforces(context, filters) {
        let top = filters.top;
        delete filters.top;
        return AllCompanyWorkforces.objects.filter(filters, { top: top });
    },

    fetchAllWorkforceFacilities(context, filters) {
        return AllWorkforceFacilities.objects.filter(filters);
    },

    addFacilityToWorkforce(context, data) {
        let pk = data.workforce_id;
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return AllCompanyWorkforces.objects.update({ pk }, form);
    },

    fetchSimpleWorkforceExecutives(context,filters) {
        return simpleWorkforceExecutives.objects.filter(filters);
    },

    fetchWorkforceImageAmazonFormData() {
        return AWSWorkforceImage.objects.filter()
            .then(data => data.amazon)
            .catch(error => { console.error(error); });
    },

    fetchWorkforcesList(context, filters) {
        return WorkforcesList.objects.filter(filters).then(data => {
            context.commit('setWorkforces', data);
            return data;
        });
    },

    getSimpleWorkforce(context, pk) {
        return WorkforcesList.objects.get(pk);
    },

    fetchSidebarWorkforces(context, filters) {
        return NavigationWorkforce.objects.filter(filters);
    },

    async fetchWorkforceSidebarTodos({ state, commit }, filters) {
        if (state.isFetchingWorkforceSidebarTodo) return;
        commit('setIsFetchingWorkforceSidebarTodo', true);

        try {
            const data = await WorkforceWorkforceTodoCount.objects.filter(filters);
            commit('setWorkforceSidebarTodoCount', data.workforce_todos_count);
            return data;
        } catch (err) {
            console.error('Error fetching workforce sidebar todos:', err);
        } finally {
            commit('setIsFetchingWorkforceSidebarTodo', false);
        }
    },

    fetchPlatformSettingsWorkforces(context, filters) {
        return PlatformSettingsWorkforce.objects.filter(filters);
    },

    inviteWorkforceExecutive(context, data) {
        const form = new FormData();
        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return WorkforceExecutiveInvitation.objects.create(form);
    },

    fetchWorkforceOnboardingEmployees(context, filters) {
        return WorkforceOnboardEmployees.objects.filter(filters);
    },

    fetchWorkforceFacilitites(context, filters) {
        return WorkforceFacilitites.objects.filter(filters);
    },

    fetchWorkforceFacilityEmployments(context, filters) {
        return WorkforceFacilityEmployments.objects.filter(filters);
    },

    updateFacilityDetailsResource(context, payload) {
        const form = new FormData();

        form.append('employees', JSON.stringify(payload.employees));

        return FacilityDetailsResource.objects.update({ 'pk': payload.pk }, form);
    },

    fetchWorkforcesAndDepartments(context, filters) {
        return WorkforcesAndDepartments.objects.filter(filters);
    },

    async archiveOrUnarchiveWorkforce(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        await Workforce.objects.update({pk}, formData);
    },

    getUserPinnedWorkforces(context, pk) {
        return UserPinnedWorkforces.objects.get(pk);
    },

    pinWorkforce(context, data) {
        return UserPinnedWorkforces.objects.create(data);
    },

    unpinWorkforce(context, data) {
        return UserPinnedWorkforces.objects.delete(data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
